// CategoryDeleteConfirmModal Component
// Confirmation modal for deleting categories and files/folders

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';
import './CategoryDeleteConfirmModal.css';

export function CategoryDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  item = null, // { type: 'file'|'folder'|'multiple'|'category', name: string, path: string, items?: array }
  isLoading = false
}) {
  if (!item) {
    return null;
  }

  const isFolder = item.type === 'folder';
  const isMultiple = item.type === 'multiple';
  const isCategory = item.type === 'category';

  let message;
  if (isMultiple) {
    message = `Are you sure you want to delete ${item.items.length} selected items? This action cannot be undone.`;
  } else if (isFolder) {
    message = `Are you sure you want to delete the folder "${item.name}" and all its contents? This action cannot be undone.`;
  } else if (isCategory) {
    message = `Are you sure you want to delete the category "${item.name}"? This action cannot be undone.`;
  } else {
    message = `Are you sure you want to delete the file "${item.name}"? This action cannot be undone.`;
  }

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete"
      showCloseButton={true}
    >
      <div className="delete-confirm-content">
        <p className="delete-confirm-message">{message}</p>
        <div className="delete-confirm-actions">
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="danger"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default CategoryDeleteConfirmModal;